import * as msgpack from '@mta/msgpack-js-lib';
import ExtendableError from 'es6-error';

export default class ExternalUserNotFoundException extends ExtendableError {
	constructor(
			/** string */ message = ''
	) {
		super(message);
	}

	/**
	 * @param {!object} os
	 * @param {!function} genericTypePackers
	 * @param {Number} __uid__
	 * @return {object}
	 */
	pack(os, genericTypePackers, __uid__) {
		return {
			__uid__: __uid__,
		};
	}

	/**
	 * @param {!object} is
	 * @param {ExternalUserNotFoundException} value
	 */
	unpack(is, value) {
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.common.user.ExternalUserNotFoundException', ExternalUserNotFoundException);
